import React, { forwardRef } from 'react';

const TableBody = forwardRef(function TableBody({ children, empty, colSpan, ...props }, ref) {
  return (
    <tbody ref={ref} {...props}>
      {children ?? (empty ? <tr><td colSpan={colSpan}>{empty}</td></tr> : null)}
    </tbody>
  );
});

TableBody.tableSection = 'tbody';
export default TableBody;
